import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 114px 200px 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;
  font-family: 'Montserrat', sans-serif;
`

export const TableHeadCell = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  color: #414141;
`

export const TableRow = styled.span`
  grid-column: 1 / span 3;

  display: grid;
  grid-template-columns: 114px 200px 1fr;
  grid-gap: 10px;
`

export const TableRowCell = styled.span`
  align-self: center;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.blue900};
  text-decoration: none;
`

export const DocumentNameWrapper = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-decoration: none;

  svg {
    margin-right: 18px;
  }

  span:hover {
    font-weight: 600;

    ~ svg {
      path {
        stroke: ${theme.colors.blue900};
      }
    }
  }
`

export const DocumentNameLink = styled.span`
  width: calc(100% - 34px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${theme.colors.blue900};
`
